export * from './suspiciousTransactions.component';
